export enum EInvoicingEvent {
    RECEIVED = 'einvoicing:received',
}

export interface EInvoicingEventMap {
    [EInvoicingEvent.RECEIVED]: void;
}
